export interface RegionBounds {
  name: string;
  MIN_LATITUDE: number;
  MAX_LATITUDE: number;
  MIN_LONGITUDE: number;
  MAX_LONGITUDE: number;
}

const VALID_REGIONS: RegionBounds[] = [
  {
    name: 'North America',
    MIN_LATITUDE: 7,
    MAX_LATITUDE: 83,
    MIN_LONGITUDE: -179,
    MAX_LONGITUDE: -20,
  },
] as const;

export const SNT_DEVICE_CONSTANTS = {
  LOCATION: {
    VALID_REGIONS,
    MAX_LAST_VALID_LOCATION: 2, // in days
  },
  COMMUNICATION: {
    CHECKIN_TIMEOUT: 48, // in hours
  },
} as const;

/**
 * Slap-and-Track device configuration used by install verification tags.
 *
 * - firmware.versionRegex: validates firmware version format for classification
 * - location.validRegions: array of geographic regions with coordinate bounds for GPS validation
 * - location.lastValidLocationTimeRange: time threshold for location timestamp validation
 */
export const sntConfig = {
  health: {
    location: {
      validRegions: SNT_DEVICE_CONSTANTS.LOCATION.VALID_REGIONS,
      lastValidLocationTimeRange: SNT_DEVICE_CONSTANTS.LOCATION.MAX_LAST_VALID_LOCATION,
    },
    communication: {
      checkinTimeout: SNT_DEVICE_CONSTANTS.COMMUNICATION.CHECKIN_TIMEOUT,
    },
  },
} as const;
